<template>
  <div class="ui-pop" v-show="show">
    <div class="ui-mask"></div>
    <div class="ui-modal large scroll">
      <p class="modal-title">{{$t('TERMS')}}</p>
      <a class="modal-close" @click="closePop"><i class="el-icon-close"></i></a>
      <div class="content terms">
        <p>
          Newton Academic Tuition Company Limited ("Newton Academic Tuition")
          acts as the agent on behalf of the tutor ("Tutor") and will introduce
          the Tutor to the client ("Client") through the use of Newton Academic
          Tuition's website www.newtontutor.hk and its app "Newton Academic
          Tuition".
        </p>
        <p>Fees and Payment</p>
        <p>
          • Lessons are payable in advance to Newton Academic Tuition, at an
          hourly rate set by Newton Academic Tuition, depending on the Tutor’s
          grade (standard, higher or super).
        </p>
        <p>
          • The Client is responsible for checking invoices in relation to
          his/her account credit balance, to ensure that correct payment has
          been made and deducted from his/her account credit balance for
          tutorial lessons confirmed and booked in the tutorial timetable.
        </p>
        <p>
          • The Client must not, under any circumstances, make direct payments
          to the Tutor at any time.
        </p>
        <p>Expenses</p>
        <p>
          • Any expenses for learning material e.g. textbooks or equipment used
          for learning by the Client during tutorial lessons must be borne by
          the Client.
        </p>
        <p>Non–solicitation</p>
        <p>
          • The Client must not, under any circumstances, make private
          arrangements for tutorial lessons with a Tutor introduced by Newton
          Academic Tuition. If this obligation is breached, the Client is then
          liable to account to Newton Academic Tuition for all sums paid to the
          Tutor without deduction, and Newton Academic Tuition shall be entitled
          to obtain an injunction against a Client to prevent further breaches.
          This obligation shall continue notwithstanding termination of this
          agreement.
        </p>
        <p>Liability</p>
        <p>
          • Newton Academic Tuition provides an online introduction service,
          acting as an agent for Client and Tutor. All our tutors are carefully
          interviewed, but they are not employees if Newton Academic Tuition. It
          is the Client’s responsibility to ensure that adequate adult
          supervision is in place during tutorial lessons. Clients are also
          recommended to record and keep videos of tutorial lessons in order to
          safeguard the integrity of the lessons and to maintain a safe online
          environment.
        </p>
        <p>
          • Newton Academic Tuition accepts no liability for any claims by the
          Client arising out of or related to tutoring by a Tutor introduced by
          Newton Academic Tuition.
        </p>
        <p>Cancellation Policy</p>
        <p>
          • As a general rule, the Client and the Tutor are responsible for
          notifying one another in advance of any necessary changes to the
          timing of any tutorial lessons that are already booked. Wherever
          possible, an alternative date and/or time will be arranged and
          mutually agreed upon between the Client and the Tutor. For more
          details, see "Rules for Cancelling and Rescheduling Lessons" as below.
        </p>
        <p>
          • Newton Academic Tuition operates a strict cancellation and
          rescheduling policy on the part of the Client, and reserves the right
          to charge the Client in full if a lesson is cancelled at short notice,
          or if the Client misses a lesson. See "Rules for Cancelling and
          Rescheduling Lessons" for further information as below.
        </p>
        <p>
          • If the Client does not show up for a tutorial lesson more than
          fifteen minutes after the lesson is due to commence, the lesson is
          deemed "missed" by the Client. Under such circumstances, the Client is
          charged in full for the lesson, and the Tutor is paid the full amount
          of the lesson.
        </p>
        <p>
          • A Tutor is allowed to cancel any booked tutorial lesson, as long as
          the cancellation is made officially via Newton Academic Tuition's
          website
          <a target="_blank" href="https://www.newtontutor.hk"
            >www.newtontutor.hk</a
          >
          or its app "Newton Academic Tuition", at any time before the start of
          the lesson.
        </p>
        <p>Rules for Cancelling and Rescheduling Lessons</p>
        <p>Client</p>
        <p>
          • Cancellation - possible up to 48 hours in advance of the agreed
          starting time of the lesson.
        </p>
        <p>
          • Upon successful cancellation, full credit for the lesson is returned
          to the Client’s account, usable for future booking of lessons with the
          same or another Tutor.
        </p>
        <p>
          • Rescheduling (1) – possible up to 24 hours in advance of the start
          of the lesson. The Client can change the tuition time slot to another
          one that is shown to be available in the same Tutor’s timetable. If
          the new tuition time slot is within one week of the original lesson,
          no approval is required from the Tutor.If the Client wants to
          reschedule the lesson to an available tuition time slot more than a
          week after the original lesson, approval is required from the Tutor,
          which may or may not be granted, depending on the Tutor’s availability
          and discretion.
        </p>
        <p>
          • Rescheduling (2) – under 24 hours in advance of the start of the
          lesson. The Client can change the tuition time slot to another one
          that is shown to be available in the same Tutor’s timetable. If the
          new tuition time slot is within 24 hours of the original lesson, no
          approval is required from the Tutor.If the Client wants to reschedule
          the lesson to an available tuition time slot more than 24 hours away
          from the original lesson, approval is required from the Tutor, which
          may or may not be granted, depending on the Tutor’s availability and
          discretion.
        </p>
        <p>
          • Any lesson can only be rescheduled once without approval from the
          Tutor. If subsequent rescheduling is required, approval is required
          from the Tutor, which may or may not be granted, depending on the
          Tutor’s availability and discretion.
        </p>

        <p>
          • In both the above rescheduling scenarios, if Tutor approval is
          required but is declined by the Tutor, the Client’s credit for the
          lesson is not returned, and the Tutor is paid the full amount of the
          lesson.
        </p>
        <p>Tutor</p>
        <p>
          • Cancellation – A Tutor can cancel a lesson at any time before the
          start of the lesson.
        </p>
        <p>
          • If a Tutor wants to cancel a lesson, the cancellation must be
          submitted via the Newton Academic Tuition website or app before the
          agreed starting time of the lesson, with an accompanying message to
          the Client via Newton Academic Tuition’s instant messaging system
          giving the reason, as a matter of courtesy.
        </p>
        <p>
          • If a Tutor cancels a lesson, full credit of the lesson is returned
          to the Client’s account. (A Tutor would of course normally refrain
          from cancelling any lesson, because there is no guarantee that the
          income for that particular lesson will be recouped at another time).
        </p>
        <p>
          If a Tutor cancels a lesson, the Tutor may then reschedule it by
          arranging an alternative time by mutual agreement between Tutor and
          Client via Newton Academic Tuition’s instant messaging system. The
          Client has the right to accept or decline such rearrangement of the
          lesson.
        </p>
        <p>
          • If the Tutor does not cancel before the start of the lesson and does
          not turn up for the lesson, this is considered to be a "no show".
        </p>
        <p>
          • In the event of a "no show" by the Tutor, full credit of the lesson
          is returned to the Client’s account.
        </p>
        <p>Data Protection & Retention</p>
        <p>
          • Newton Academic Tuition will only use any data held to communicate
          with the Client about lessons, progress reports, invoicing and other
          marketing information about Newton Academic Tuition services where
          relevant.
        </p>
        <p>
          • All Client data will be held securely within the Newton Academic
          Tuition database and for a maximum of 1 year after the Client has
          cancelled his/her account with Newton Academic Tuition. All Clients
          have the right to request to see what data Newton Academic Tuition
          holds by emailing
          <a href="https://enquiry@newtontutor.hk" target="_blank"
            >enquiry@newtontutor.hk</a
          >, and they will receive a response within 30 calendar days.
        </p>
        <p>General</p>
        <p>
          • Newton Academic Tuition reserves the right to alter these Terms and
          Conditions at any time without prior notice.
        </p>
        <p>
          • For any alterations or variations of these Terms and Conditions to
          be valid, they must first be approved in writing by a majority of
          Directors of Newton Academic Tuition.
        </p>
        <p>
          • Unless otherwise agreed in writing by a majority of Directors of
          Newton Academic Tuition, these Terms and Conditions shall prevail over
          any other Terms of Business or Conditions put forward by the Client.
        </p>
        <p>Approval</p>
        <p>
          • Acceptance and use of Newton Academic Tuition's services will be
          taken to represent agreement to these Terms and Conditions.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['show'],
  methods: {
    closePop() {
      this.$parent.show = false
    },
  },
}
</script>
<style lang="scss" scoped>
.terms {
  padding: 50px;
  font-size: 14px;
  line-height: 1.5;
  p {
    margin-top: 20px;
  }
}
@media screen and (max-width: 768px) {
  .terms {
    padding: 20px;
  }
}
</style>